import React from 'react';
import {
	BrowserRouter,
	Redirect,
	Route,
	Switch
} from 'react-router-dom';

import { log } from '../../services/utils';

import Login from './Login';
import ResetPass from './ResetPass';
import TwoFactor from './TwoFactor';

const AuthRouter = () => (
	<BrowserRouter>
		{ log( 'authRouter' ) }
		<Switch>
			<Route
				exact
				path="/login"
				component={ Login }
			/>
			<Route
				exact
				path="/authenticate"
				component={ TwoFactor }
			/>
			<Route
				path="/reset/:penCode"
				component={ ResetPass }
			/>
			<Redirect
				from="*"
				to="/login"
			/>
		</Switch>
	</BrowserRouter>
);

export default AuthRouter;
